import React, { useState, useEffect } from 'react'
import AuthHeader from '../../components/Navbar/AuthHeader'
import { Link } from 'react-router-dom'
import { MdOutlineMarkEmailRead } from "react-icons/md";
import { FcGoogle } from "react-icons/fc";
import { FaFacebook } from "react-icons/fa";
import { FaApple } from "react-icons/fa";
import ProgressSteps from '../../components/ProgressStep/ProgressSteps';
import { useNavigate } from 'react-router-dom';
import { verifyEmail } from '../../actions/auth';
import { FaArrowLeftLong } from 'react-icons/fa6';
import GoogleAuth from '../../components/SocialAuth/GoogleAuth';

function EmailVerification() {
    const [email, setEmail] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const navigate = useNavigate();
    const account_type = localStorage.getItem('account_type');
    const publicUrl = process.env.REACT_APP_PUBLIC_URL;

    useEffect(() => {
        if (!account_type) {
            navigate('/getstarted', { replace: true });
        }
    }, [account_type, navigate]);

    const handleSignup = async (e) => {
        e.preventDefault();

        if (!account_type){
            console.error("Account type not found!");
            navigate('/getstarted', { replace: true });
            return;
        }

        if (!email) return; 

        // navigate('/personal/signup');

        await verifyEmail(email, navigate, setIsLoading, setSuccessMessage, setErrorMessage);
    };

    if (!account_type) {
        return null;
    }

  return (
    <div style={{background: '#13053A',minHeight: '100vh'}}>
            <AuthHeader />
            <div className="auth__container padding__tb_30">
                <div className='auth__container__box'>
                    <div>
                        <Link to='/getstarted'>
                            <FaArrowLeftLong className='auth__back__arrow' />
                        </Link>
                    </div>
                    <h3>Create your account</h3>
                    <p className='auth__text'>Already have an account? <Link to='/login' className='text-decoration-none'>Login</Link></p>
                   
                    {/* Progress Dots */}
                    <ProgressSteps currentStep={2} totalSteps={4} />

                    <div className='auth__container__form'>
                        <form onSubmit={handleSignup}>
                            {errorMessage && <p className="text-center text-danger error-container text-capitalize">{errorMessage}</p>}
                            {successMessage && <p className="text-center text-success success-container text-capitalize">{successMessage}</p>}
                            <div className='form__group mb-4'>
                                <label htmlFor='email' className='label__form'>Enter your email address  </label>
                                <div className="input-group">
                                    <span className='auth__input__group'><MdOutlineMarkEmailRead /></span>
                                    <input 
                                        type="email" 
                                        id="email"
                                        className='auth__input' 
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)} 
                                        required
                                    />
                                </div>
                            </div>
                            <div className='form__group'>
                                <button type='submit' className='btn btn__block'>
                                    {isLoading ? (
                                        <div className="spinner-border spinner-border-sm text-light" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    ) : 'Continue'}  
                                </button>
                            </div>
                        </form>

                        {/* <div style={{ paddingTop: '35px'}}>
                            <p className='auth__text__small text-center'>Or sign up using</p>
                        </div> */}

                        {/* <div className='create__account__social'> */}
                            {/* <Link className="social__account__box">
                                <GoogleAuth userAction={'register'} setIsLoading={setIsLoading} />
                            </Link> */}
                            {/* <Link className='social__account__box'>
                                <FaFacebook className='social__account__icon' />
                            </Link>
                            <Link className='social__account__box'>
                                <FaApple className='social__account__icon last' />
                            </Link> */}
                        {/* </div> */}
                        <div className='mt-4 mb-5'>
                            <p className='auth__container__box__text'>
                                By registering you accept our 
                                <Link to={`${publicUrl}/legal`} rel='noopener noreferrer' target='_blank'> Terms of use </Link> 
                                and <Link to={`${publicUrl}/privacy-policy`} rel='noopener noreferrer' target='_blank'> Privacy Policy</Link>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
    </div>
  )
}

export default EmailVerification